import React, { useState, useEffect } from "react";
import axios from 'axios';
import { getUser,aPIURL,auTHURL } from '../utils/common.js';


function Contactus(props)
{
  const API_URL=aPIURL();
  
  //alert(props.id);
  const devid= props.id;
  const [defaultCenter, setPosts] = useState([]);
  //const url=process.env.REACT_APP_APIURL+'DeviceLog/'+devid;
  const url = API_URL+`DeviceLog/${devid}`;
  //alert(url);

    useEffect(() => {
      (async () => {
        const response = await axios.get(url);
        console.log(response);
        const data = response.data.data;
        setPosts(data);
      })();
    }, []);
    const iframeData = document.getElementById("iframeId");
    let imin=0;
    let _deviceName=0;
    let dSpeed=0;
    defaultCenter.map((item) =>
    {
        imin=item.imeiNumber;
        _deviceName=item.deviceName;
        dSpeed=item.speed;
        iframeData.src = `https://maps.google.com/maps?q=${item.latitude},${item.longitude}&hl=es;&output=embed`;
     });
  return (
    <div>
      <span style={{ fontSize:"14px"}}>
      <b> Device Name : </b>{_deviceName} &nbsp;&nbsp;&nbsp;&nbsp;<b> IEMI Number : </b>{imin} &nbsp;&nbsp;&nbsp;&nbsp;<b> Speed : </b>{dSpeed} Km/h</span>
      <iframe title="Map" id="iframeId" height="400px" width="100%" frameborder="0" loading="lazy" allowfullscreen></iframe>
    </div>);
}
export default Contactus;
